<template>
  <div class="app-wrapper" :class="classObj">
    <!-- 固定在顶部的导航栏 -->
    <div class="top-sidebar">
      <topSidebar></topSidebar>
    </div>
    
    <!-- 内容容器（包含可滚动的主体内容） -->
    <div class="content-wrapper">
      <div class="main-content">
        <app-main></app-main>
      </div>
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain, topSidebar } from './components'
import ResizeMixin from './mixin/ResizeHandler'

export default {
  name: 'layout',
  components: {
    Navbar,
    Sidebar,
    AppMain,
    topSidebar
  },
  mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    topSidebar() {
      return this.$store.state.app.topSidebar
    },
    device() {
      return this.$store.state.app.device
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/mixin.scss";

.app-wrapper {
  @include clearfix;
  min-height: 100vh;
  width: 100%;
  min-width: 0;
  background: #f4f7fb;
  /* 给固定导航栏留出空间 */
  padding-top: 64px;
}

/* 固定在顶部的导航栏 */
.top-sidebar {
  position: fixed; /* 固定定位 */
  top: 0; /* 顶部对齐 */
  left: 0; /* 左侧对齐 */
  right: 0; /* 右侧对齐，确保导航栏占满宽度 */
  z-index: 1000; /* 确保在内容上方 */
  height: 64px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 2px 10px rgba(31, 49, 77, 0.04);
  border-bottom: 1px solid #e5eaf2;
}

/* 内容容器 */
.content-wrapper {
  padding: 18px 20px 24px;
  width: 100%;
  min-width: 0;
  max-width: 100%; /* 改为100%宽度，不限制最大宽度 */
  box-sizing: border-box;
}

/* 主体内容区域（可滚动） */
.main-content {
  min-height: calc(100vh - 64px - 42px);
  background: #f4f7fb;
  border-radius: 14px;
  box-shadow: none;
  padding: 20px;
  position: relative;
  overflow: visible; /* 允许内容溢出 */
  width: 100%;
  min-width: 0;
  max-width: 100%;
  
}

@media (max-width: 1280px) {
  .content-wrapper {
    padding: 16px;
  }

  .main-content {
    min-height: calc(100vh - 64px - 32px);
    padding: 16px;
  }
}

@media (max-width: 960px) {
  .content-wrapper {
    padding: 12px;
  }

  .main-content {
    min-height: calc(100vh - 64px - 24px);
    padding: 12px;
  }
}

/* 手机端保留一级导航栏，二级菜单由整屏抽屉承载 */
@media (max-width: 768px), (max-width: 960px) and (max-height: 540px) and (orientation: landscape) {
  .app-wrapper {
    padding-top: calc(104px + env(safe-area-inset-top));
    min-height: 100vh;
    min-height: 100dvh;
    min-height: var(--app-viewport-height, 100dvh);
  }

  .top-sidebar {
    height: calc(104px + env(safe-area-inset-top));
    padding-top: env(safe-area-inset-top);
  }

  .content-wrapper {
    padding: 8px;
    padding-right: calc(8px + env(safe-area-inset-right));
    padding-bottom: calc(8px + env(safe-area-inset-bottom));
    padding-left: calc(8px + env(safe-area-inset-left));
  }

  .main-content {
    min-height: calc(100vh - 104px - env(safe-area-inset-top) - 16px);
    min-height: calc(100dvh - 104px - env(safe-area-inset-top) - 16px);
    min-height: calc(var(--app-viewport-height, 100dvh) - 104px - env(safe-area-inset-top) - 16px);
    padding: 8px;
    border-radius: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue